// Dark und Light sind gleichwertig. Ohne gespeicherte Wahl folgt die Oberfläche
// dem Betriebssystem (docs/design.md).

export type Theme = 'dark' | 'light'
export type ThemeChoice = Theme | 'system'

const STORAGE_KEY = 'netzwarte.theme'

export function systemTheme(): Theme {
  if (typeof window === 'undefined' || !window.matchMedia) return 'dark'
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

export function storedChoice(): ThemeChoice {
  if (typeof localStorage === 'undefined') return 'system'
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'dark' || v === 'light' ? v : 'system'
}

export function resolveTheme(choice: ThemeChoice): Theme {
  return choice === 'system' ? systemTheme() : choice
}

export function applyTheme(choice: ThemeChoice): Theme {
  const theme = resolveTheme(choice)
  document.documentElement.setAttribute('data-theme', theme)
  document.documentElement.style.colorScheme = theme
  return theme
}

export function storeChoice(choice: ThemeChoice): void {
  if (typeof localStorage === 'undefined') return
  if (choice === 'system') localStorage.removeItem(STORAGE_KEY)
  else localStorage.setItem(STORAGE_KEY, choice)
}
